import { Box } from 'designSystem/components/Box'
import type { ReactElement, ReactNode } from 'react'

import { LotoStatusActions } from './lotoPagePanel.styles'

type LotoReportStatusLineProps = {
  statusText: ReactNode
  actions: ReactNode
  message?: ReactNode
}

export function LotoReportStatusLine({
  statusText,
  actions,
  message,
}: LotoReportStatusLineProps): ReactElement {
  return (
    <Box display='flex' direction='column' gap='xs'>
      <Box display='flex' align='center' gap='xsPlus' wrap='wrap'>
        <Box display='flex' align='center' gap='xsPlus' minWidth='none'>
          {statusText}
        </Box>
        <LotoStatusActions>{actions}</LotoStatusActions>
      </Box>
      {message}
    </Box>
  )
}
